import { useState, useEffect } from "react";
import { Table } from "antd";
import styled from "styled-components";
import { GroupExcelForm } from "../../../Components/Template";
import { getListGroupExcels } from "../../../api/admin"

export default function GroupExcel() {
	const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
	const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getListGroupExcels();
            setDataSource(response.data);
        } catch (error) {
            console.error("데이터 로드 실패:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

	const columns = [
        {
            title: "No",
            dataIndex: "idx",
            key: "idx",
            render: (text, record, index) => dataSource.length - index
        },
        { title: "단체명", dataIndex: "name", key: "name" },
		{ title: "등록인원", dataIndex: "num", key: "num" },
        { title: "파일명", dataIndex: "file", key: "file" },
        { 
            title: "등록일",  
            dataIndex: "created", 
            key: "created",
            render: (text) => new Date(text).toLocaleString()
        },
    ];

	return (
		<Container>
			<GroupExcelForm />
			<hr style={{ margin: "25px 0" }} />

			{/* 데이터 리스트 테이블 */}
            <h3>업로드 내역(※ 파일은 DB에 저장되지 않음)</h3>
            <Table 
                dataSource={dataSource} 
                columns={columns} 
                rowKey="id"
                loading={loading}
                pagination={false}
            />
		</Container>
	);
}

const Container = styled.div({
	padding: "50px 20px",
});
